import React from "react";

// Both pricebook and static/manual discounts show the original price
// struck-through plus the discounted price (green for pricebook, blue for static).
const STRIKETHROUGH_STYLE = { textDecoration: "line-through", color: "#aaa", marginRight: 5 };
const PB_DISCOUNT_STYLE = { color: "#276749", fontWeight: 600 };
const STATIC_DISCOUNT_STYLE = { color: "#3a90dd", fontWeight: 600 };

const DiscountedPriceCell = ({ originalPrice, discountedPrice, isDiscounted, isPbDiscounted }) => {
  if (!discountedPrice) {
    return <span>{originalPrice}</span>;
  }

  if (isPbDiscounted) {
    return (
      <span>
        <span style={STRIKETHROUGH_STYLE}>{originalPrice}</span>
        <span style={PB_DISCOUNT_STYLE}>{discountedPrice}</span>
      </span>
    );
  }

  if (isDiscounted) {
    return (
      <span>
        <span style={STRIKETHROUGH_STYLE}>{originalPrice}</span>
        <span style={STATIC_DISCOUNT_STYLE}>{discountedPrice}</span>
      </span>
    );
  }

  return <span>{originalPrice}</span>;
};

export default DiscountedPriceCell;
